import { Button, Grid, Snackbar, TextField } from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {

    const loginUrl = "https://us-central1-packers-node.cloudfunctions.net/api/user/login";

    const navigate = useNavigate();

    const token = localStorage.getItem("token");

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
    });

    if (token) {
        navigate("/manage");
    }

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: yup.object({
            username: yup
                .string()
                .required("Required"),
            password: yup.string().required("Required"),
        }),
        onSubmit: async (values) => {
            axios
                .post(loginUrl, values)
                .then((res) => {
                    if (res.data.status && res.data.message === "Login successful") {
                        localStorage.setItem("token", res.data.data.accessToken);
                        navigate("/manage");
                    } else {
                        setSnackbar({
                            open: true,
                            message: "Invalid username or password",
                        });
                    }
                }).catch((err) => {
                    if (err.response.data.message) {
                        setSnackbar({
                            open: true,
                            message: err.response.data.message,
                        });
                    }
                    console.log(err);
                });
        },
    });

    return (
        <Grid
            container
            sx={{
                minHeight: "100vh",
                minWidth: "100vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Grid xs={6} sx={{ padding: "20px", border: "1px solid black", borderRadius: "10px", backgroundColor: "#002496" }}>
                <form onSubmit={formik.handleSubmit}>
                    <Grid xs={6} sx={{ padding: "20px" }}>
                        <img
                            src='https://www.naturalpackersandmovers.com/wp-content/uploads/2024/05/NPM-Logo.png'
                            className="logo"
                        />
                    </Grid>
                    <Grid item xs={12} mb={2}>
                        <TextField
                            fullWidth
                            id='username'
                            name='username'
                            label='Username'
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.username && Boolean(formik.errors.username)}
                            helperText={formik.touched.username && formik.errors.username}
                            sx={{ backgroundColor: "#f8f9fa" }}
                        />
                    </Grid>
                    <Grid item xs={12} mb={2}>
                        <TextField
                            fullWidth
                            type='password'
                            id='password'
                            name='password'
                            label='Password'
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            sx={{ backgroundColor: "#f8f9fa" }}
                        />
                    </Grid>
                    <Grid sx={10}>
                        <Button type='submit' fullWidth variant='contained'>
                            Login
                        </Button>
                    </Grid>
                </form>
            </Grid>
            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={snackbar.open}
                onClose={() => {
                    setSnackbar({ ...snackbar, open: false });
                }}
                message={snackbar.message}
            />
        </Grid>
    );
};

export default Login;
